import { Container } from 'react-bootstrap';
import Tabs from '../../components/Tabs/Tabs';
import EmploymentHistory from '../widgets/pensionProfileTabs/EmploymentHistory';
import PayHistory from '../widgets/pensionProfileTabs/PayHistory';
import Summary from '../widgets/pensionProfileTabs/Summary';

const tabs = [
  {
    name: 'Summary',
    content: <Summary />,
  },

  {
    name: 'Employment History',
    content: <EmploymentHistory />,
  },

  {
    name: 'Pay History',
    content: <PayHistory />,
  },
];

const PensionProfile = () => {
  return (
    <Container className={'cnd-custom-container px-0 mt-11 mt-lg-13'}>
      <Container className={'mb-7 mb-lg-10'}>
        <h2 className={'text-sm-20-lg-32 fw-light'}>Pension Profile</h2>
      </Container>
      <Container className={'px-0'}>
        <Tabs tabs={tabs} />
      </Container>
    </Container>
  );
};

export default PensionProfile;
